import { Box, Button, Divider, Grid, Paper, Popover, Tooltip, Typography } from "@mui/material";
import "../css/BookingCalendar.css";
import { hourLabel, HOURS } from "../../../constants/DateUtils";
import { isEmpty, printDebugLog, StayType } from "../../../constants/Constants";
import { useEffect, useState } from "react";
import { CHECK_IN_TIME, CHECK_OUT_TIME } from "../../../constants/pojoservice";


const TimePanel = (
    {
        selectedDate,
        previousTimeBooking,
        currentTimeSlot,
        fetchBooking,
        checkInOutFocus,
        handleCheckInTimeAddPartial,
        handleCheckOutTimeAddPartial,
        checkInDateStr,
        checkOutDateStr
    }
) => {

    useEffect(() => {
        printDebugLog("TimePanel checkInOutFocus", checkInOutFocus)
    }, [checkInOutFocus])

    useEffect(() => {
        printDebugLog("TimePanel previousTimeBooking", previousTimeBooking)
    }, [previousTimeBooking])

    const [hourAnchor, setHourAnchor] = useState(null);
    const hourOpen = Boolean(hourAnchor);
    const [popContent, setPopContent] = useState(null);

    const openHourPopover = (event, content) => {
        setHourAnchor(event.currentTarget);
        setPopContent(content);
    };
    const closeHourPopover = () => {
        setHourAnchor(null);
        setPopContent(null);
    };

    const getBookedStatus = (h) => {
        //printDebugLog("getBookedStatus", h, currentTimeSlot);
        if (previousTimeBooking.has(h)) {
            return true;
        }
        return currentTimeSlot.indexOf(h) !== -1;
    };

    function checkAndBook(event, h) {
        printDebugLog("checkAndBook", h);
        if (previousTimeBooking.has(h)) {
            const data = previousTimeBooking.get(h);
            openHourPopover(event, <PopPreviousContent data={data} h={h} />);
        } else if (currentTimeSlot.indexOf(h) !== -1) {
            openHourPopover(event, <PopCurrentContent h={h} />);
        } else {
            if (checkInOutFocus === CHECK_IN_TIME) {
                handleCheckInTimeAddPartial(h);
            } else if (checkInOutFocus === CHECK_OUT_TIME) {
                handleCheckOutTimeAddPartial(h);
            }
        }
    }

    const getDuration = (data) => {
        if (data.bookingType === -1) {
            return "";
        }
        return `${data.totalStay} ${data.bookingType === StayType.DAILY ? "days" : "hours"}`;
    }

    function PopPreviousContent({ data, h }) {
        return (
            <div className="bk-popover-content">
                <div className="bk-popover-row">
                    <span className="bk-popover-label">Time</span>
                    <span className="bk-popover-value">
                        {hourLabel(h)}
                    </span>
                </div>
                <div className="bk-popover-row">
                    <span className="bk-popover-label">Booking Id</span>
                    <span className="bk-popover-value">{data.bookingId}</span>
                </div>
                <div className="bk-popover-row">
                    <span className="bk-popover-label">Check In</span>
                    <span className="bk-popover-value">{data.checkInDateStr}</span>
                </div>
                <div className="bk-popover-row">
                    <span className="bk-popover-label">Check Out</span>
                    <span className="bk-popover-value">{data.checkoutDateStr}</span>
                </div>
                <div className="bk-popover-row">
                    <span className="bk-popover-label">Duration</span>
                    <span className="bk-popover-value">{getDuration(data)}</span>
                </div>
                <span
                    style={{
                        color: data.confirmedBooking ? "green" : "red",
                        fontWeight: "bold",
                        textAlign: "center",
                        display: "block"
                    }}
                >
                    {data.confirmedBooking ? "Booking Confirmed" : "Booking yet to be confirmed"}
                </span>
                <div className="bk-popover-actions">
                    <Button size="small" onPointerDown={() => closeHourPopover()}>
                        Ok
                    </Button>
                    {
                        !isEmpty(data.billId) &&
                        <Button size="small" onPointerDown={() => {
                            closeHourPopover();
                            fetchBooking(data.billId);
                        }}>
                            Fetch Booking
                        </Button>
                    }
                </div>

            </div>
        )
    }

    function PopCurrentContent({ h }) {
        return (
            <div className="bk-popover-content">
                <div className="bk-popover-row">
                    <span className="bk-popover-label">Time</span>
                    <span className="bk-popover-value">
                        {hourLabel(h)}
                    </span>
                </div>
                <div className="bk-popover-row">
                    <span className="bk-popover-label">Check In</span>
                    <span className="bk-popover-value">{checkInDateStr}</span>
                </div>

                <div className="bk-popover-row">
                    <span className="bk-popover-label">Check Out</span>
                    <span className="bk-popover-value">{checkOutDateStr}</span>
                </div>
                <span
                    style={{
                        color: "red",
                        fontStyle: "italic",
                        textAlign: "center",
                        fontSize: "12px",
                        display: "block"
                    }}
                >
                    {"Initiation Phase"}
                </span>
                <div className="bk-popover-actions">
                    <Button size="small" onPointerDown={() => closeHourPopover()}>
                        Ok
                    </Button>
                    <Button size="small" onPointerDown={() => closeHourPopover()}>
                        Clear
                    </Button>
                </div>
            </div>
        )
    }


    return (
        <>
            <Grid item xs={12} md={6}>
                <Paper elevation={2} className="bk-panel">
                    <Box className="bk-day-header">
                        <Typography variant="subtitle1" fontWeight={700}>
                            {selectedDate.toLocaleDateString(undefined, {
                                weekday: "long",
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                            })}
                        </Typography>
                        <Box className="bk-legend">
                            <span className="legend-box legend-booked" /> Booked
                            <span className="legend-box legend-free" /> Free
                        </Box>
                    </Box>
                    <Divider />
                    <div className="bk-scroll-area">
                        <Box
                            className="bk-hours"
                        >
                            {HOURS.map((h) => {
                                const booked = getBookedStatus(h);
                                //className={`bk-hour ${booked ? "bk-hour--booked" : ""}}`}
                                return (
                                    <Tooltip
                                        key={h}
                                        title={`${hourLabel(h)} • ${booked ? "Booked" : "Available"}`}
                                        arrow
                                        enterDelay={150}
                                    >
                                        <div
                                            className={booked ? "bk-booked" : "bk-hour"}
                                            role="button"
                                            onClick={(e) => checkAndBook(e, h)}
                                        >
                                            <span className="bk-hourlabel">
                                                {String(h).padStart(2, "0")}:00
                                            </span>
                                        </div>
                                    </Tooltip>
                                );
                            })}
                        </Box>
                    </div>
                </Paper>
            </Grid>
            <Popover
                open={hourOpen}
                anchorEl={hourAnchor}
                onClose={closeHourPopover}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                PaperProps={{ className: "bk-popover-paper" }}
            >
                {popContent}
            </Popover>
        </>
    )
}

export { TimePanel };